<ng-container *ngIf="event?.id && (hasNewTurnoverData !== undefined)">
  <ng-container *ngIf="hasNewTurnoverData; else oldTurnoverData">
    <app-statistics-new [event]="event"></app-statistics-new>
  </ng-container>
  <ng-template #oldTurnoverData>
    <app-statistics-old [event]="event"></app-statistics-old>
  </ng-template>
</ng-container>
